// You can write more code here

/* START OF COMPILED CODE */

import SpringWaterSparkle0 from '@/game/prefabs/World/Effects/SpringWaterSparkle0';
import SpringWaterSparkle1 from '@/game/prefabs/World/Effects/SpringWaterSparkle1';
import SpringWaterSparkle2 from '@/game/prefabs/World/Effects/SpringWaterSparkle2';
import ForestTree1 from '@/game/prefabs/World/ForestTree1';
import Mentor2 from '@/game/prefabs/World/Mentors/Mentor2';
import Player from '@/game/prefabs/World/Player';
import Portal from '@/game/prefabs/World/Portal';
import WorldNode from '@/game/prefabs/World/WorldNode';
import TilemapScene from './TilemapScene';
/* START-USER-IMPORTS */
/* END-USER-IMPORTS */

export default class Level7 extends TilemapScene {
  constructor() {
    super('Level7');

    /* START-USER-CTR-CODE */
    // Write your code here.
    /* END-USER-CTR-CODE */
  }

  editorCreate(): void {
    // spring_biome_3
    const spring_biome_3 = this.add.tilemap('spring-biome-3');
    spring_biome_3.addTilesetImage(
      'spring forest wang tiles',
      'spring forest wang tiles',
    );
    spring_biome_3.addTilesetImage('spring forest', 'spring forest');
    spring_biome_3.addTilesetImage(
      'spring water sparkles B',
      'spring water sparkles B',
    );
    spring_biome_3.addTilesetImage(
      'spring trees 80x112',
      'spring trees 80x112',
    );

    // terrain_1
    spring_biome_3.createLayer('terrain', ['spring forest wang tiles'], 0, 0);

    // waterfalls_1
    spring_biome_3.createLayer('waterfalls', ['spring forest'], 0, 0);

    // cliffs_1
    spring_biome_3.createLayer('cliffs', ['spring forest'], 0, 0);

    // splashes_1
    spring_biome_3.createLayer('splashes', ['spring forest'], 0, 0);

    // deco_1
    spring_biome_3.createLayer('deco', ['spring forest'], 0, 0);

    // deco_16x
    spring_biome_3.createLayer('deco 16x32', [], 0, 0);

    // waterSparkles
    spring_biome_3.createLayer(
      'sparkles (spring water sparkles B)',
      ['spring water sparkles B'],
      0,
      0,
    );

    // forestTree1
    const forestTree1 = new ForestTree1(this, 24, 96, 'spring_trees_sheet', 2);
    this.add.existing(forestTree1);

    // forestTree
    const forestTree = new ForestTree1(this, 104, 48, 'spring_trees_sheet', 2);
    this.add.existing(forestTree);

    // forestTree_1
    const forestTree_1 = new ForestTree1(
      this,
      152,
      112,
      'spring_trees_sheet',
      2,
    );
    this.add.existing(forestTree_1);

    // forestTree_2
    const forestTree_2 = new ForestTree1(
      this,
      360,
      48,
      'spring_trees_sheet',
      2,
    );
    this.add.existing(forestTree_2);

    // forestTree_3
    const forestTree_3 = new ForestTree1(
      this,
      264,
      240,
      'spring_trees_sheet',
      2,
    );
    this.add.existing(forestTree_3);

    // forestTree_4
    const forestTree_4 = new ForestTree1(
      this,
      312,
      288,
      'spring_trees_sheet',
      2,
    );
    this.add.existing(forestTree_4);

    // forestTree_5
    const forestTree_5 = new ForestTree1(
      this,
      600,
      288,
      'spring_trees_sheet',
      2,
    );
    this.add.existing(forestTree_5);

    // forestTree_6
    const forestTree_6 = new ForestTree1(
      this,
      648,
      64,
      'spring_trees_sheet',
      2,
    );
    this.add.existing(forestTree_6);

    // forestTree_7
    const forestTree_7 = new ForestTree1(
      this,
      824,
      264,
      'spring_trees_sheet',
      2,
    );
    this.add.existing(forestTree_7);

    // forestTree_8
    const forestTree_8 = new ForestTree1(
      this,
      520,
      480,
      'spring_trees_sheet',
      2,
    );
    this.add.existing(forestTree_8);

    // forestTree_9
    const forestTree_9 = new ForestTree1(
      this,
      328,
      488,
      'spring_trees_sheet',
      2,
    );
    this.add.existing(forestTree_9);

    // forestTree_10
    const forestTree_10 = new ForestTree1(
      this,
      200,
      544,
      'spring_trees_sheet',
      2,
    );
    this.add.existing(forestTree_10);

    // forestTree_11
    const forestTree_11 = new ForestTree1(
      this,
      152,
      592,
      'spring_trees_sheet',
      2,
    );
    this.add.existing(forestTree_11);

    // forestTree_12
    const forestTree_12 = new ForestTree1(
      this,
      72,
      592,
      'spring_trees_sheet',
      2,
    );
    this.add.existing(forestTree_12);

    // forestTree_13
    const forestTree_13 = new ForestTree1(
      this,
      56,
      80,
      'spring_trees_sheet',
      0,
    );
    this.add.existing(forestTree_13);

    // forestTree_14
    const forestTree_14 = new ForestTree1(
      this,
      232,
      32,
      'spring_trees_sheet',
      0,
    );
    this.add.existing(forestTree_14);

    // forestTree_15
    const forestTree_15 = new ForestTree1(
      this,
      392,
      48,
      'spring_trees_sheet',
      0,
    );
    this.add.existing(forestTree_15);

    // forestTree_16
    const forestTree_16 = new ForestTree1(
      this,
      600,
      48,
      'spring_trees_sheet',
      0,
    );
    this.add.existing(forestTree_16);

    // forestTree_17
    const forestTree_17 = new ForestTree1(
      this,
      680,
      48,
      'spring_trees_sheet',
      0,
    );
    this.add.existing(forestTree_17);

    // forestTree_18
    const forestTree_18 = new ForestTree1(
      this,
      792,
      32,
      'spring_trees_sheet',
      0,
    );
    this.add.existing(forestTree_18);

    // forestTree_19
    const forestTree_19 = new ForestTree1(
      this,
      840,
      480,
      'spring_trees_sheet',
      0,
    );
    this.add.existing(forestTree_19);

    // forestTree_20
    const forestTree_20 = new ForestTree1(
      this,
      104,
      592,
      'spring_trees_sheet',
      0,
    );
    this.add.existing(forestTree_20);

    // forestTree_21
    const forestTree_21 = new ForestTree1(
      this,
      40,
      560,
      'spring_trees_sheet',
      0,
    );
    this.add.existing(forestTree_21);

    // forestTree_22
    const forestTree_22 = new ForestTree1(
      this,
      104,
      112,
      'spring_trees_sheet',
      1,
    );
    this.add.existing(forestTree_22);

    // forestTree_23
    const forestTree_23 = new ForestTree1(
      this,
      280,
      32,
      'spring_trees_sheet',
      1,
    );
    this.add.existing(forestTree_23);

    // forestTree_24
    const forestTree_24 = new ForestTree1(
      this,
      312,
      128,
      'spring_trees_sheet',
      1,
    );
    this.add.existing(forestTree_24);

    // forestTree_25
    const forestTree_25 = new ForestTree1(
      this,
      456,
      80,
      'spring_trees_sheet',
      1,
    );
    this.add.existing(forestTree_25);

    // forestTree_26
    const forestTree_26 = new ForestTree1(
      this,
      232,
      240,
      'spring_trees_sheet',
      1,
    );
    this.add.existing(forestTree_26);

    // forestTree_27
    const forestTree_27 = new ForestTree1(
      this,
      472,
      352,
      'spring_trees_sheet',
      1,
    );
    this.add.existing(forestTree_27);

    // forestTree_28
    const forestTree_28 = new ForestTree1(
      this,
      536,
      304,
      'spring_trees_sheet',
      1,
    );
    this.add.existing(forestTree_28);

    // forestTree_29
    const forestTree_29 = new ForestTree1(
      this,
      712,
      96,
      'spring_trees_sheet',
      1,
    );
    this.add.existing(forestTree_29);

    // forestTree_30
    const forestTree_30 = new ForestTree1(
      this,
      840,
      112,
      'spring_trees_sheet',
      1,
    );
    this.add.existing(forestTree_30);

    // forestTree_31
    const forestTree_31 = new ForestTree1(
      this,
      864,
      560,
      'spring_trees_sheet',
      1,
    );
    this.add.existing(forestTree_31);

    // forestTree_32
    const forestTree_32 = new ForestTree1(
      this,
      392,
      560,
      'spring_trees_sheet',
      1,
    );
    this.add.existing(forestTree_32);

    // forestTree_33
    const forestTree_33 = new ForestTree1(
      this,
      168,
      560,
      'spring_trees_sheet',
      1,
    );
    this.add.existing(forestTree_33);

    // forestTree_34
    const forestTree_34 = new ForestTree1(this, 16, 80, 'spring 32x', 0);
    this.add.existing(forestTree_34);

    // forestTree_35
    const forestTree_35 = new ForestTree1(this, 48, 128, 'spring 32x', 0);
    this.add.existing(forestTree_35);

    // forestTree_36
    const forestTree_36 = new ForestTree1(this, 352, 32, 'spring 32x', 0);
    this.add.existing(forestTree_36);

    // forestTree_37
    const forestTree_37 = new ForestTree1(this, 432, 32, 'spring 32x', 0);
    this.add.existing(forestTree_37);

    // forestTree_38
    const forestTree_38 = new ForestTree1(this, 432, 80, 'spring 32x', 0);
    this.add.existing(forestTree_38);

    // forestTree_39
    const forestTree_39 = new ForestTree1(this, 768, 64, 'spring 32x', 0);
    this.add.existing(forestTree_39);

    // forestTree_40
    const forestTree_40 = new ForestTree1(this, 816, 48, 'spring 32x', 0);
    this.add.existing(forestTree_40);

    // forestTree_41
    const forestTree_41 = new ForestTree1(this, 528, 336, 'spring 32x', 0);
    this.add.existing(forestTree_41);

    // forestTree_42
    const forestTree_42 = new ForestTree1(this, 272, 288, 'spring 32x', 0);
    this.add.existing(forestTree_42);

    // forestTree_43
    const forestTree_43 = new ForestTree1(this, 304, 272, 'spring 32x', 0);
    this.add.existing(forestTree_43);

    // forestTree_44
    const forestTree_44 = new ForestTree1(this, 32, 576, 'spring 32x', 0);
    this.add.existing(forestTree_44);

    // forestTree_45
    const forestTree_45 = new ForestTree1(this, 208, 576, 'spring 32x', 0);
    this.add.existing(forestTree_45);

    // forestTree_46
    const forestTree_46 = new ForestTree1(this, 464, 576, 'spring 32x', 0);
    this.add.existing(forestTree_46);

    // forestTree_47
    const forestTree_47 = new ForestTree1(this, 816, 560, 'spring 32x', 0);
    this.add.existing(forestTree_47);

    // worldNode
    const worldNode = new WorldNode(this, 88, 136);
    this.add.existing(worldNode);

    // worldNode_1
    const worldNode_1 = new WorldNode(this, 376, 80);
    this.add.existing(worldNode_1);

    // worldNode_2
    const worldNode_2 = new WorldNode(this, 584, 112);
    this.add.existing(worldNode_2);

    // worldNode_3
    const worldNode_3 = new WorldNode(this, 480, 256);
    this.add.existing(worldNode_3);

    // worldNode_4
    const worldNode_4 = new WorldNode(this, 240, 512);
    this.add.existing(worldNode_4);

    // worldNode_5
    const worldNode_5 = new WorldNode(this, 576, 552);
    this.add.existing(worldNode_5);

    // portal
    const portal = new Portal(this, 752, 568);
    this.add.existing(portal);

    // player
    const player = new Player(this, 224, 96);
    this.add.existing(player);

    // waterSparklesContainer
    const waterSparklesContainer = this.add.container(0, 0);

    // _0springWaterSparkle
    const _0springWaterSparkle = new SpringWaterSparkle0(this, 144, 264);
    waterSparklesContainer.add(_0springWaterSparkle);

    // _0springWaterSparkle_1
    const _0springWaterSparkle_1 = this.add.sprite(
      160,
      280,
      'spring water sparkles B_spritesheet',
      0,
    );
    _0springWaterSparkle_1.play('0springWaterSparkle');
    waterSparklesContainer.add(_0springWaterSparkle_1);

    // _0springWaterSparkle_2
    const _0springWaterSparkle_2 = this.add.sprite(
      248,
      328,
      'spring water sparkles B_spritesheet',
      0,
    );
    _0springWaterSparkle_2.play('0springWaterSparkle');
    waterSparklesContainer.add(_0springWaterSparkle_2);

    // _0springWaterSparkle_3
    const _0springWaterSparkle_3 = this.add.sprite(
      40,
      176,
      'spring water sparkles B_spritesheet',
      0,
    );
    _0springWaterSparkle_3.play('0springWaterSparkle');
    waterSparklesContainer.add(_0springWaterSparkle_3);

    // _0springWaterSparkle_4
    const _0springWaterSparkle_4 = this.add.sprite(
      624,
      184,
      'spring water sparkles B_spritesheet',
      0,
    );
    _0springWaterSparkle_4.flipX = true;
    _0springWaterSparkle_4.play('0springWaterSparkle');
    waterSparklesContainer.add(_0springWaterSparkle_4);

    // _0springWaterSparkle_5
    const _0springWaterSparkle_5 = this.add.sprite(
      704,
      136,
      'spring water sparkles B_spritesheet',
      0,
    );
    _0springWaterSparkle_5.flipX = true;
    _0springWaterSparkle_5.play('0springWaterSparkle');
    waterSparklesContainer.add(_0springWaterSparkle_5);

    // _0springWaterSparkle_6
    const _0springWaterSparkle_6 = this.add.sprite(
      688,
      152,
      'spring water sparkles B_spritesheet',
      0,
    );
    _0springWaterSparkle_6.flipX = true;
    _0springWaterSparkle_6.play('0springWaterSparkle');
    waterSparklesContainer.add(_0springWaterSparkle_6);

    // _0springWaterSparkle_7
    const _0springWaterSparkle_7 = this.add.sprite(
      744,
      232,
      'spring water sparkles B_spritesheet',
      0,
    );
    _0springWaterSparkle_7.flipX = true;
    _0springWaterSparkle_7.play('0springWaterSparkle');
    waterSparklesContainer.add(_0springWaterSparkle_7);

    // _0springWaterSparkle_8
    const _0springWaterSparkle_8 = this.add.sprite(
      696,
      520,
      'spring water sparkles B_spritesheet',
      0,
    );
    _0springWaterSparkle_8.flipX = true;
    _0springWaterSparkle_8.play('0springWaterSparkle');
    waterSparklesContainer.add(_0springWaterSparkle_8);

    // _0springWaterSparkle_9
    const _0springWaterSparkle_9 = this.add.sprite(
      240,
      440,
      'spring water sparkles B_spritesheet',
      0,
    );
    _0springWaterSparkle_9.flipX = true;
    _0springWaterSparkle_9.play('0springWaterSparkle');
    waterSparklesContainer.add(_0springWaterSparkle_9);

    // _0springWaterSparkle_10
    const _0springWaterSparkle_10 = this.add.sprite(
      96,
      456,
      'spring water sparkles B_spritesheet',
      0,
    );
    _0springWaterSparkle_10.flipX = true;
    _0springWaterSparkle_10.play('0springWaterSparkle');
    waterSparklesContainer.add(_0springWaterSparkle_10);

    // SpringWaterSparkle1
    const springWaterSparkle1 = new SpringWaterSparkle1(this, 224, 440);
    waterSparklesContainer.add(springWaterSparkle1);

    // SpringWaterSparkle3
    const springWaterSparkle3 = new SpringWaterSparkle1(this, 80, 456);
    waterSparklesContainer.add(springWaterSparkle3);

    // SpringWaterSparkle3_1
    const springWaterSparkle3_1 = new SpringWaterSparkle1(this, 160, 264);
    springWaterSparkle3_1.flipX = false;
    springWaterSparkle3_1.flipY = true;
    waterSparklesContainer.add(springWaterSparkle3_1);

    // SpringWaterSparkle3_2
    const springWaterSparkle3_2 = new SpringWaterSparkle1(this, 128, 248);
    springWaterSparkle3_2.flipX = false;
    springWaterSparkle3_2.flipY = true;
    waterSparklesContainer.add(springWaterSparkle3_2);

    // SpringWaterSparkle3_3
    const springWaterSparkle3_3 = new SpringWaterSparkle1(this, 56, 176);
    springWaterSparkle3_3.flipX = false;
    springWaterSparkle3_3.flipY = true;
    waterSparklesContainer.add(springWaterSparkle3_3);

    // SpringWaterSparkle3_4
    const springWaterSparkle3_4 = new SpringWaterSparkle1(this, 32, 240);
    springWaterSparkle3_4.flipX = false;
    springWaterSparkle3_4.flipY = true;
    waterSparklesContainer.add(springWaterSparkle3_4);

    // SpringWaterSparkle3_5
    const springWaterSparkle3_5 = new SpringWaterSparkle1(this, 264, 328);
    springWaterSparkle3_5.flipX = false;
    springWaterSparkle3_5.flipY = true;
    waterSparklesContainer.add(springWaterSparkle3_5);

    // SpringWaterSparkle3_6
    const springWaterSparkle3_6 = new SpringWaterSparkle1(this, 240, 288);
    springWaterSparkle3_6.flipX = false;
    springWaterSparkle3_6.flipY = true;
    waterSparklesContainer.add(springWaterSparkle3_6);

    // SpringWaterSparkle3_7
    const springWaterSparkle3_7 = new SpringWaterSparkle1(this, 200, 280);
    springWaterSparkle3_7.flipX = false;
    springWaterSparkle3_7.flipY = true;
    waterSparklesContainer.add(springWaterSparkle3_7);

    // SpringWaterSparkle3_8
    const springWaterSparkle3_8 = new SpringWaterSparkle1(this, 640, 184);
    springWaterSparkle3_8.flipX = false;
    springWaterSparkle3_8.flipY = true;
    waterSparklesContainer.add(springWaterSparkle3_8);

    // SpringWaterSparkle3_9
    const springWaterSparkle3_9 = new SpringWaterSparkle1(this, 576, 176);
    springWaterSparkle3_9.flipX = true;
    springWaterSparkle3_9.flipY = true;
    waterSparklesContainer.add(springWaterSparkle3_9);

    // SpringWaterSparkle3_10
    const springWaterSparkle3_10 = new SpringWaterSparkle1(this, 704, 120);
    springWaterSparkle3_10.flipX = true;
    springWaterSparkle3_10.flipY = true;
    waterSparklesContainer.add(springWaterSparkle3_10);

    // SpringWaterSparkle3_11
    const springWaterSparkle3_11 = new SpringWaterSparkle1(this, 752, 96);
    springWaterSparkle3_11.flipX = true;
    springWaterSparkle3_11.flipY = true;
    waterSparklesContainer.add(springWaterSparkle3_11);

    // SpringWaterSparkle3_12
    const springWaterSparkle3_12 = new SpringWaterSparkle1(this, 600, 80);
    springWaterSparkle3_12.flipX = true;
    springWaterSparkle3_12.flipY = true;
    waterSparklesContainer.add(springWaterSparkle3_12);

    // SpringWaterSparkle3_13
    const springWaterSparkle3_13 = new SpringWaterSparkle1(this, 800, 128);
    springWaterSparkle3_13.flipX = true;
    springWaterSparkle3_13.flipY = true;
    waterSparklesContainer.add(springWaterSparkle3_13);

    // SpringWaterSparkle3_14
    const springWaterSparkle3_14 = new SpringWaterSparkle1(this, 680, 520);
    springWaterSparkle3_14.flipX = true;
    springWaterSparkle3_14.flipY = true;
    waterSparklesContainer.add(springWaterSparkle3_14);

    // SpringWaterSparkle3_15
    const springWaterSparkle3_15 = new SpringWaterSparkle1(this, 624, 480);
    springWaterSparkle3_15.flipX = true;
    springWaterSparkle3_15.flipY = true;
    waterSparklesContainer.add(springWaterSparkle3_15);

    // SpringWaterSparkle3_16
    const springWaterSparkle3_16 = new SpringWaterSparkle1(this, 336, 560);
    springWaterSparkle3_16.flipX = true;
    springWaterSparkle3_16.flipY = true;
    waterSparklesContainer.add(springWaterSparkle3_16);

    // SpringWaterSparkle3_17
    const springWaterSparkle3_17 = new SpringWaterSparkle1(this, 288, 448);
    springWaterSparkle3_17.flipX = true;
    springWaterSparkle3_17.flipY = true;
    waterSparklesContainer.add(springWaterSparkle3_17);

    // SpringWaterSparkle3_18
    const springWaterSparkle3_18 = new SpringWaterSparkle1(this, 136, 480);
    springWaterSparkle3_18.flipX = true;
    springWaterSparkle3_18.flipY = true;
    waterSparklesContainer.add(springWaterSparkle3_18);

    // SpringWaterSparkle3_19
    const springWaterSparkle3_19 = new SpringWaterSparkle1(this, 232, 352);
    springWaterSparkle3_19.flipX = true;
    springWaterSparkle3_19.flipY = true;
    waterSparklesContainer.add(springWaterSparkle3_19);

    // springWaterSparkle2
    const springWaterSparkle2 = new SpringWaterSparkle2(this, 232, 328);
    waterSparklesContainer.add(springWaterSparkle2);

    // springWaterSparkle
    const springWaterSparkle = new SpringWaterSparkle2(this, 216, 280);
    waterSparklesContainer.add(springWaterSparkle);

    // springWaterSparkle_1
    const springWaterSparkle_1 = new SpringWaterSparkle2(this, 176, 272);
    waterSparklesContainer.add(springWaterSparkle_1);

    // springWaterSparkle_2
    const springWaterSparkle_2 = new SpringWaterSparkle2(this, 104, 200);
    springWaterSparkle_2.flipX = true;
    springWaterSparkle_2.flipY = false;
    waterSparklesContainer.add(springWaterSparkle_2);

    // springWaterSparkle_3
    const springWaterSparkle_3 = new SpringWaterSparkle2(this, 48, 264);
    springWaterSparkle_3.flipX = true;
    springWaterSparkle_3.flipY = false;
    waterSparklesContainer.add(springWaterSparkle_3);

    // springWaterSparkle_4
    const springWaterSparkle_4 = new SpringWaterSparkle2(this, 128, 296);
    springWaterSparkle_4.flipX = true;
    springWaterSparkle_4.flipY = false;
    waterSparklesContainer.add(springWaterSparkle_4);

    // springWaterSparkle_5
    const springWaterSparkle_5 = new SpringWaterSparkle2(this, 680, 192);
    springWaterSparkle_5.flipX = true;
    springWaterSparkle_5.flipY = false;
    waterSparklesContainer.add(springWaterSparkle_5);

    // springWaterSparkle_6
    const springWaterSparkle_6 = new SpringWaterSparkle2(this, 776, 136);
    springWaterSparkle_6.flipX = true;
    springWaterSparkle_6.flipY = false;
    waterSparklesContainer.add(springWaterSparkle_6);

    // springWaterSparkle_7
    const springWaterSparkle_7 = new SpringWaterSparkle2(this, 784, 72);
    springWaterSparkle_7.flipX = true;
    springWaterSparkle_7.flipY = false;
    waterSparklesContainer.add(springWaterSparkle_7);

    // springWaterSparkle_8
    const springWaterSparkle_8 = new SpringWaterSparkle2(this, 688, 136);
    springWaterSparkle_8.flipX = true;
    springWaterSparkle_8.flipY = false;
    waterSparklesContainer.add(springWaterSparkle_8);

    // springWaterSparkle_9
    const springWaterSparkle_9 = new SpringWaterSparkle2(this, 632, 168);
    springWaterSparkle_9.flipX = true;
    springWaterSparkle_9.flipY = false;
    waterSparklesContainer.add(springWaterSparkle_9);

    // springWaterSparkle_10
    const springWaterSparkle_10 = new SpringWaterSparkle2(this, 576, 192);
    springWaterSparkle_10.flipX = false;
    springWaterSparkle_10.flipY = false;
    waterSparklesContainer.add(springWaterSparkle_10);

    // springWaterSparkle_11
    const springWaterSparkle_11 = new SpringWaterSparkle2(this, 544, 72);
    springWaterSparkle_11.flipX = false;
    springWaterSparkle_11.flipY = false;
    waterSparklesContainer.add(springWaterSparkle_11);

    // springWaterSparkle_12
    const springWaterSparkle_12 = new SpringWaterSparkle2(this, 760, 232);
    springWaterSparkle_12.flipX = false;
    springWaterSparkle_12.flipY = false;
    waterSparklesContainer.add(springWaterSparkle_12);

    // springWaterSparkle_13
    const springWaterSparkle_13 = new SpringWaterSparkle2(this, 640, 480);
    springWaterSparkle_13.flipX = false;
    springWaterSparkle_13.flipY = false;
    waterSparklesContainer.add(springWaterSparkle_13);

    // springWaterSparkle_14
    const springWaterSparkle_14 = new SpringWaterSparkle2(this, 680, 536);
    springWaterSparkle_14.flipX = false;
    springWaterSparkle_14.flipY = false;
    waterSparklesContainer.add(springWaterSparkle_14);

    // springWaterSparkle_15
    const springWaterSparkle_15 = new SpringWaterSparkle2(this, 648, 512);
    springWaterSparkle_15.flipX = false;
    springWaterSparkle_15.flipY = false;
    waterSparklesContainer.add(springWaterSparkle_15);

    // mentor
    const mentor = new Mentor2(this, 264, 64);
    this.add.existing(mentor);

    // worldNode_6
    const worldNode_6 = new WorldNode(this, 792, 576);
    this.add.existing(worldNode_6);

    // worldNode_7
    const worldNode_7 = new WorldNode(this, 296, 360);
    this.add.existing(worldNode_7);

    // worldNode_8
    const worldNode_8 = new WorldNode(this, 384, 160);
    this.add.existing(worldNode_8);

    // worldNode_9
    const worldNode_9 = new WorldNode(this, 448, 536);
    this.add.existing(worldNode_9);

    // worldNode (prefab fields)
    worldNode.NPCLevelId = 0;
    worldNode.NPCId = 0;

    // worldNode_1 (prefab fields)
    worldNode_1.NPCLevelId = 6;
    worldNode_1.NPCId = 1;

    // worldNode_2 (prefab fields)
    worldNode_2.NPCLevelId = 6;
    worldNode_2.NPCId = 2;

    // worldNode_3 (prefab fields)
    worldNode_3.NPCLevelId = 6;
    worldNode_3.NPCId = 3;

    // worldNode_4 (prefab fields)
    worldNode_4.NPCLevelId = 6;
    worldNode_4.NPCId = 4;

    // worldNode_5 (prefab fields)
    worldNode_5.NPCLevelId = 6;
    worldNode_5.NPCId = 5;

    // worldNode_6 (prefab fields)
    worldNode_6.NPCLevelId = 6;
    worldNode_6.NPCId = 5;

    // worldNode_7 (prefab fields)
    worldNode_7.NPCLevelId = 6;
    worldNode_7.NPCId = 5;

    // worldNode_8 (prefab fields)
    worldNode_8.NPCLevelId = 6;
    worldNode_8.NPCId = 5;

    // worldNode_9 (prefab fields)
    worldNode_9.NPCLevelId = 6;
    worldNode_9.NPCId = 5;

    this.portal = portal;
    this.player = player;
    this.mentor = mentor;
    this.spring_biome_3 = spring_biome_3;

    this.events.emit('scene-awake');
  }

  private portal!: Portal;
  private player!: Player;
  private mentor!: Mentor2;
  private spring_biome_3!: Phaser.Tilemaps.Tilemap;

  /* START-USER-CODE */

  // Write your code here

  create() {
    this.editorCreate();
    this.initialize({
      camera: this.cameras.main,
      player: this.player,
      tilemap: this.spring_biome_3,
      portal: this.portal,
      mentor: this.mentor,
    });
  }

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
